/**
 * Persistencia local (por navegador) de la HOJA ACTIVA seleccionada en el dashboard.
 *
 * La lista de hojas disponibles ya no se persiste — se descubre en runtime
 * leyendo el htmlview público del Google Sheet (ver `src/api/sheetsList.js`).
 *
 * Convenciones para el valor de `active`:
 *   - ''         → "Hoja por defecto" (la primera del Google Sheet,
 *                  es decir, gviz sin parámetro `sheet=`).
 *   - '__ALL__'  → modo agregado: fetcheamos TODAS las hojas detectadas en
 *                  paralelo y combinamos las filas en un solo dataset.
 *   - cualquier  → nombre exacto de pestaña (gviz con `&sheet=NOMBRE`).
 *     otro string
 */

export const ALL_SHEETS = '__ALL__';

const KEY = 'dashboard.activeSheet.v1';

// Migración silenciosa desde la v1 anterior que guardaba { sheets, active }.
// Si encontramos esa forma vieja en localStorage, extraemos solo el `active`.
(function migrate() {
  try {
    const oldRaw = localStorage.getItem('dashboard.sheets.v1');
    if (oldRaw && !localStorage.getItem(KEY)) {
      const old = JSON.parse(oldRaw);
      if (old && typeof old.active === 'string' && old.active) {
        localStorage.setItem(KEY, old.active);
      }
      localStorage.removeItem('dashboard.sheets.v1');
    }
  } catch (e) {}
})();

export function getActiveSheet() {
  try {
    return localStorage.getItem(KEY) || '';
  } catch (e) {
    return '';
  }
}

export function setActiveSheet(name) {
  try {
    if (name) localStorage.setItem(KEY, name);
    else localStorage.removeItem(KEY);
  } catch (e) {}
}
